<div class="segment-details-modal" [class.visible]="visible" (click)="onClose()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="modal-header">
      <div class="header-content">
        <h2 class="modal-title">Segment Details</h2>
        <button class="close-button" (click)="onClose()">
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13 1L1 13M1 1L13 13"
              stroke="#555963"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
    <!-- Segment Info Header -->
    <div class="segment-info-header" *ngIf="segment">
      <div class="segment-title-section">
        <div class="segment-title-row">
          <h3 class="segment-name">{{ segment.name }}</h3>
          <span class="segment-status" [ngClass]="getStatusClass(segment.segment_status)">
            {{ getStatusDisplay(segment.segment_status) }}
          </span>
        </div>
        <p class="created-by">{{ segment.description }}</p>
      </div>
      <div
        class="dropdown-container"
        appClickOutside
        [appClickOutsideEnabled]="showDropdown"
        (appClickOutside)="showDropdown = false"
        (click)="onDropdownClick($event)"
      >
        <button class="action-button" (click)="toggleDropdown()">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8 2.66667C8.73638 2.66667 9.33333 3.26362 9.33333 4C9.33333 4.73638 8.73638 5.33333 8 5.33333C7.26362 5.33333 6.66667 4.73638 6.66667 4C6.66667 3.26362 7.26362 2.66667 8 2.66667ZM8 6.66667C8.73638 6.66667 9.33333 7.26362 9.33333 8C9.33333 8.73638 8.73638 9.33333 8 9.33333C7.26362 9.33333 6.66667 8.73638 6.66667 8C6.66667 7.26362 7.26362 6.66667 8 6.66667ZM8 10.6667C8.73638 10.6667 9.33333 11.2636 9.33333 12C9.33333 12.7364 8.73638 13.3333 8 13.3333C7.26362 13.3333 6.66667 12.7364 6.66667 12C6.66667 11.2636 7.26362 10.6667 8 10.6667Z"
              fill="#15172E"
            />
          </svg>
        </button>

        <div class="dropdown-menu" [class.show]="showDropdown" (click)="onDropdownClick($event)">
          <div class="dropdown-item" (click)="onEditSegment()">
            <span class="dropdown-text">Edit</span>
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.25 6L5.41667 7.16667L7.75 4.83333M0.75 6C0.75 6.68944 0.885795 7.37213 1.14963 8.00909C1.41347 8.64605 1.80018 9.2248 2.28769 9.71231C2.7752 10.1998 3.35395 10.5865 3.99091 10.8504C4.62787 11.1142 5.31056 11.25 6 11.25C6.68944 11.25 7.37213 11.1142 8.00909 10.8504C8.64605 10.5865 9.2248 10.1998 9.71231 9.71231C10.1998 9.2248 10.5865 8.64605 10.8504 8.00909C11.1142 7.37213 11.25 6.68944 11.25 6C11.25 5.31056 11.1142 4.62787 10.8504 3.99091C10.5865 3.35395 10.1998 2.7752 9.71231 2.28769C9.2248 1.80018 8.64605 1.41347 8.00909 1.14963C7.37213 0.885795 6.68944 0.75 6 0.75C5.31056 0.75 4.62787 0.885795 3.99091 1.14963C3.35395 1.41347 2.7752 1.80018 2.28769 2.28769C1.80018 2.7752 1.41347 3.35395 1.14963 3.99091C0.885795 4.62787 0.75 5.31056 0.75 6Z"
                stroke="#555963"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div class="dropdown-divider"></div>
          <div class="dropdown-item delete-item" (click)="onDeleteSegment()">
            <span class="dropdown-text">Delete</span>
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.33203 3.08333H10.6654M4.83203 5.41667V8.91667M7.16536 5.41667V8.91667M1.91536 3.08333L2.4987 10.0833C2.4987 10.3928 2.62161 10.6895 2.84041 10.9083C3.0592 11.1271 3.35595 11.25 3.66536 11.25H8.33203C8.64145 11.25 8.9382 11.1271 9.15699 10.9083C9.37578 10.6895 9.4987 10.3928 9.4987 10.0833L10.082 3.08333M4.2487 3.08333V1.33333C4.2487 1.17862 4.31016 1.03025 4.41955 0.920854C4.52895 0.811458 4.67732 0.75 4.83203 0.75H7.16536C7.32007 0.75 7.46845 0.811458 7.57784 0.920854C7.68724 1.03025 7.7487 1.17862 7.7487 1.33333V3.08333"
                stroke="#DA1E28"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
    <!-- Content -->
    <div class="modal-body" *ngIf="segment">
      <!-- Segment Summary -->
      <div class="segment-summary">
        <h4 class="section-title">Segment Summary</h4>
        <div class="summary-card">
          <div class="summary-header">
            <div class="summary-title-section">
              <div class="summary-title-row">
                <h5 class="summary-name">{{ segment.name }}</h5>
                <!-- <p class="summary-count">{{ segment.total_customers }} <span style="color: #717683;font-size: 14px">customers</span></p> -->
              </div>
            </div>
          </div>

          <div class="summary-description">
            <p>{{ segment.description }}</p>
          </div>

          <div class="divider"></div>

          <div class="summary-stats">
            <div class="stats-row">
              <div class="stat-item">
                <span class="stat-label">TOTAL CUSTOMERS</span>
                <span class="stat-value">{{ segment.total_customers }}</span>
              </div>
              <div class="stat-item">
                <span class="stat-label">ACTIVE CUSTOMERS</span>
                <span class="stat-value">{{ segment.active_customers }}</span>
              </div>
            </div>
            <div class="stats-row">
              <div class="stat-item">
                <span class="stat-label">INACTIVE CUSTOMERS</span>
                <span class="stat-value">{{ segment.inactive_customers }}</span>
              </div>
              <div class="stat-item">
                <span class="stat-label">UNSUBSCRIBED CUSTOMERS</span>
                <span class="stat-value">{{ segment.unsubscribed_customers }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Segment Rules -->
      <div class="segment-rules" *ngIf="hasCriteria(); else noCriteriaTemplate">
        <h4 class="section-title">Segment Rule</h4>
        <div class="rules-card">
          <!-- Loading State -->
          <div *ngIf="isLoading" class="loading-state">
            <div class="loading-spinner"></div>
            <p>Loading segment criteria...</p>
          </div>

          <!-- Dynamic Criteria Display -->
          <div *ngIf="!isLoading" class="criteria-list">
            <ng-container
              *ngFor="let criteria of getCriteriaList(); let i = index; trackBy: trackByIndex"
            >
              <div class="criteria-item">
                <div class="criteria-section">
                  <div class="criteria-header">
                    <h6 class="criteria-title">Criteria {{ i + 1 }}</h6>
                  </div>
                  <div class="criteria-content">
                    <!-- List display for vehicle makes, packages, and date criteria -->
                    <div *ngIf="shouldDisplayAsList(criteria)" class="criteria-list-display">
                      <div class="criteria-label">{{ getCriteriaLabelAndCondition(criteria) }}</div>
                      <div class="criteria-items-list">
                        <!-- Date criteria display (without checkmarks) -->
                        <div
                          *ngIf="criteria.criteria?.toLowerCase()?.includes('date')"
                          class="date-range-display"
                        >
                          <div
                            *ngFor="
                              let item of getCriteriaTypesList(criteria);
                              trackBy: trackByIndex
                            "
                            class="date-item"
                          >
                            <span class="date-text">{{ item }}</span>
                          </div>
                        </div>

                        <!-- Vehicle makes and packages display (with checkmarks) -->
                        <div
                          *ngIf="!criteria.criteria?.toLowerCase()?.includes('date')"
                          class="items-with-checkmarks"
                        >
                          <div
                            *ngFor="
                              let item of getCriteriaTypesList(criteria);
                              trackBy: trackByIndex
                            "
                            class="criteria-item-check"
                          >
                            <svg
                              width="12"
                              height="9"
                              viewBox="0 0 12 9"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M1.33594 4.4974L4.66927 7.83073L11.3359 1.16406"
                                stroke="#15172E"
                                stroke-width="1.2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                            <span class="item-text">{{ item }}</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Regular display for other criteria -->
                    <div *ngIf="!shouldDisplayAsList(criteria)" class="criteria-display">
                      <span class="criteria-text">{{ getCriteriaDisplayText(criteria) }}</span>
                    </div>
                  </div>
                </div>

                <!-- Show connector between criteria (except for the last one) -->
                <div *ngIf="i < getCriteriaList().length - 1" class="criteria-connector">
                  <span class="connector-text">{{ getJoinRuleDisplay(criteria.join_rule) }}</span>
                  <div class="connector-line"></div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <!-- No Criteria State -->
      <ng-template #noCriteriaTemplate>
        <div class="segment-rules" *ngIf="segmentDetails && !hasCriteria() && !isLoading">
          <h4 class="section-title">Segment Rule</h4>
          <div class="rules-card">
            <div class="no-criteria">
              <p>No criteria defined for this segment.</p>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>
